import React from "react";
import {
  StepCard,
  StepTitle,
  StepSubtitle,
  FormGroup,
  InputField,
  NavigationButtonsRow,
  ActionButton,
} from "../registerStyles";

export const StepClinicName = ({
  formData,
  setFormData,
  onNext,
  onBack,
}) => {
  const isFilled =
    formData.razonSocial && formData.razonSocial.trim().length > 0;

  return (
    <StepCard>
      <StepTitle>Tu Consultorio</StepTitle>
      <StepSubtitle>
        Cuentanos como se llama tu centro de atencion dental.
      </StepSubtitle>

      <FormGroup>
        <label>Nombre Comercial o Razon Social *</label>
        <InputField
          type="text"
          placeholder="Ej. Clinica Dental Sonrisas / OdontoSalud"
          value={formData.razonSocial}
          onChange={(e) =>
            setFormData({ ...formData, razonSocial: e.target.value })
          }
          required
        />
      </FormGroup>

      <NavigationButtonsRow>
        <ActionButton type="button" onClick={onBack}>
          ← Atras
        </ActionButton>
        <ActionButton
          type="button"
          primary
          disabled={!isFilled}
          onClick={onNext}
        >
          Siguiente →
        </ActionButton>
      </NavigationButtonsRow>
    </StepCard>
  );
};
